import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { observable, runInAction } from 'mobx';
import { CurrencyLayer } from '../../transportLayers/currency/CurrencyLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/** Persistent store for Currencies */

export var CurrencyStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(CurrencyStore, _BaseStore);

  function CurrencyStore() {
    var _this;

    _classCallCheck(this, CurrencyStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CurrencyStore).apply(this, arguments));
    _this.name = StoreName.Currency;
    _this.layer = new CurrencyLayer();
    _this.list = new Map();
    /**
     * Fletches all Currencies
     * returns a promise with Map of items
     */

    _this.getAll = function () {
      return _this.layer.findAll().then(function (items) {
        runInAction(function () {
          _this.list.clear();

          items.forEach(function (item) {
            _this.list.set(item.id, item);
          });
        });
        return _this.list;
      });
    };

    return _this;
  }

  return CurrencyStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], CurrencyStore.prototype, "list", void 0);